<template>
  <v-layout align-center justify-center row fill-height>
    <v-flex xs12 sm8>
      <v-card>
        <v-card-title>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="logo">MFP</div>
            </v-flex>
            <v-flex xs12>
              <h2>パスワードの再設定</h2>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-text-field type="text" label="Email" v-model="email" />
          <v-alert :value="msg.length>0" :type="alertType">{{msg}}</v-alert>
        </v-card-text>
        <v-card-actions>
          <router-link :to="{name:'login', params:{company_id:this.$route.params.company_id}}">ログイン</router-link>
          <v-spacer />
          <v-btn @click="resetPassword">再設定</v-btn>

        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import auth from '@/components/fireAuthInit'
import { authErrorCodeToMessage } from '@/utils/errorMessages.js'
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex'
export default {
  data() {    return {
      email: "",
      company: {},
      msg: "",
      alertType:"success",

    }
  },
  mounted() {
  },
  methods: {
    async resetPassword() {
      const actionCodeSettings = {
        url: 'https://www.app-works-lab.com/#/company/'+ this.$route.params.company_id +"/login",
        // url: 'http://localhost:8080/#/company/'+ this.$route.params.company_id +"/login",
        handleCodeInApp: false
      }
      this.changeLoadingState(true)
      try {
        await auth.sendPasswordResetEmail(this.email, actionCodeSettings)
        this.msg = "パスワード再設定用のメールを送付しました。ご確認ください。"
        this.alertType="success"
        this.changeLoadingState(false)
      } catch (e) {
        console.log(e)
        console.log(authErrorCodeToMessage(e.code))
        this.msg = authErrorCodeToMessage(e.code)
        this.alertType = "error"
        this.changeLoadingState(false)
      }
    },
    ...mapMutations('app', ['changeLoadingState'])
  },
  computed: {

  }
}
</script>
<style lang="css" scoped>
div.logo {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
}
</style>

